import axios from "axios";
const country = localStorage.getItem("selectedCountry");
                //  const baseURL =country !== "PK" ? "https://managekaro-intl-fa16312db8e4.herokuapp.com/" : "https://obscure-caverns-93558.herokuapp.com/"; //test
                                    const baseURL = "https://obscure-caverns-93558.herokuapp.com/"; //live
                                    // const baseURL = "https://shrouded-tor-53503.herokuapp.com/"; //test
// const baseURL = "http://api.mawesh.com/"; //sql

export default axios.create({
  baseURL,
  headers: { "Cache-Control": "no-cache", "Content-Type": "application/json" },
});




// import axios from "axios";
// import { useSelector } from "react-redux";

// const Repository = () => {
//   // const { country } = useSelector((state) => state.trial);
//   const country = localStorage.getItem("selectedCountry");
//   console.log("country ", country);

//   const baseURL = "https://shrouded-tor-53503.herokuapp.com/"
//     // country === "PK"
//       // ? "https://shrouded-tor-53503.herokuapp.com/" // test
//       // : "https://obscure-caverns-93558.herokuapp.com/"; // live

//   return axios.create({
//     baseURL,
//     headers: { "Cache-Control": "no-cache", "Content-Type": "application/json" },
//   });
// };

// export default Repository;
